// src/SemiCircleProgress.js

import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { commonservices } from "../../services/CommonServices";
ChartJS.register(ArcElement, Tooltip, Legend);

const SemiCircleProgress = ({ percentage, chartTag }) => {
    const data = {
        datasets: [
            {
                data: [percentage, (percentage > 100 ? percentage : 100) - percentage],
                backgroundColor: [(percentage > 100 ? "#F70505" : "#4CAF50"), "#E0E0E0"],
                borderWidth: 0,
                cutout: "80%",
                rotation: -90,
                circumference: 180,
            },
        ],
    };

    const options = {
        plugins: {
            tooltip: {
                enabled: false,
            },
            legend: {
                display: false,
            },
        },
        rotation: -90,
        circumference: 180,
    };

    return (
        <div className="semi-circle-progress">
            <Doughnut data={data} options={options} />
            <div className="semi-circle-progress__label">
                {commonservices.NumberCalculateValue(percentage) }%<br />
                <span>{chartTag}</span>
            </div>
        </div>
    );
};

export default SemiCircleProgress;
